import React, { useState } from 'react'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'
import { all as translations } from "../../../modules/translations/translations";
import { HTTP } from '../../../api/resources';
import SelectOptionsModal from '../../Helpers/Modal/SelectOptionsModal';

export default function AddMultipleFields({team, user, reserved_names, record_type}) {
    const [showModal, setShowModal] = useState(false)
    const [saving, setSaving] = useState(false)
    const [fields, setFields] = useState([])
    const [openModalValue, setOpenModalValue] = useState(null)
    const fieldItemShell = {
        new: `new-${fields.length}`,
        name: "New Field",
        value_type: "text",
        record_type: "donor",
        editable: true,
        visible: true,
        anchor_text: '',
        select_options: [],
        system_owned: false,
        send_notifications: false
    }
    const fieldType = ['text', 'long_text', 'date', 'link', 'select', 'dynamic']
    const naming = {donor: team.donor_title, beneficiary: team.beneficiary_title, project: team.project_title}

    const close = () => {
        setSaving(false)
        setFields([])
        setShowModal(false)
    }

    const addField = (type) => {
        let newField = {...fieldItemShell, value_type: type, new: `new-${fields.length}`}
        setFields([...fields, newField])
    }

    const capitalizeText = (str) => {
        return str
            .replaceAll('_', ' ')
            .replace(/\b\w/g, char => char.toUpperCase());
    }

    const updateField = (field, update) => {
        setFields([...fields].map(object => {
        let objectId = object.id ? object.id : object.new 
        let fieldId = field.new
        if(objectId === fieldId) {
            return {
            ...object,
            ...update
            }
        }
        else return object;
        }))
    }

    const handleDelete = (id) => {
        setFields(fields.filter(field => field.new !== id));
    }

    const save = () => {
        if (invalidData()) return
    
        setSaving(true)
        HTTP.patch(`/custom_fields/${record_type}?mass_update=true`, {
          custom_fields: fields
        }).then(response => {
          Alert.show("notice", "Settings saved!");
          setTimeout(() => {window.location.reload()}, 2000);
        }).catch(e => {
          Alert.show("error", "Could not save. Try again or refresh.");
          setSaving(false);
        })
    }

    const invalidData = () => {
        let reservedFields = reserved_names || []

        if (reservedFields.some(reservedField => fields.some(field => field.name.toLowerCase() === reservedField.toLowerCase()))) {
            Alert.show("error", "Reserved field name. Please choose a different name.");
            return true;
        }

        if (fields.some((field, index) => fields.findIndex(f => f.name.toLowerCase() === field.name.toLowerCase()) !== index)) {
            Alert.show("error", "Duplicate field name. Please choose a different name.");
            return true;
        }

        return false
    }

    const closeOptionsModal = (field, options) => {
		updateField(field, { select_options: options})
		setOpenModalValue(false)
	}

  return (
    <div>
        {/* Popup modal button */}
        <div className='text-right'>
            <button className='btn btn-primary' onClick={() => setShowModal(true)}>Add Multiple Fields</button>
        </div>

        {/* modal */}
        {showModal && (
            <div>
            <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center modal-popup-scaled-width">
                    <h4 className='text-center'>Add Multiple Fields</h4>

                    <div className="content-area text-left">
                        {/* custom field list */}
                        {(!fields || fields.length < 1) && 
                            <p><small><i>No field has been added yet, click '+ Add Field' to add a new field</i></small></p>
                        }
                        <div style={{maxHeight: '500px', overflowX: 'hidden', overflowY: 'auto', width: '100%'}}>
                            {fields.map((field, index) => (
                                <div key={index}>
                                    <div>{index > 0 && <hr />}</div>
                                    <div className="row">
                                        <div className='col-md-5'>
                                            <div className='form-group'>
                                                <label>Field Label</label>
                                                <input className='form-control' value={field.name}
                                                    onChange={(event) => {
                                                        updateField(field, { name: event.target.value });
                                                    }}
                                                />
                                            </div>

                                            <div className='form-group'>
                                                <div><label>Record Type</label></div>
                                                <select
                                                    value={field.record_type}
                                                    onChange={(event) => {updateField(field, { record_type: event.target.value })}}
                                                    className='form-control'
                                                >
                                                    <option value='donor'>{team.donor_title}</option>
                                                    <option value='beneficiary'>{team.beneficiary_title}</option>
                                                    <option value='project'>{team.project_title}</option>
                                                    <option value='sponsorship'>Sponsorship</option>
                                                </select>
                                            </div>

                                            <div className='form-group'>
                                                <div><label>Field Type</label></div>
                                                <select
                                                    value={field.value_type}
                                                    onChange={(event) => {updateField(field, { value_type: event.target.value })}}
                                                    className='form-control'
                                                >
                                                    <option value='text'>Text</option>
                                                    <option value='long_text'>Long Text</option>
                                                    <option value='date'>Date</option>
                                                    <option value='link'>Link</option>
                                                    <option value='select'>Select</option>
                                                    <option value='dynamic'>Dynamic</option>
                                                </select>
                                            </div>

                                            {!field.system_owned && field.value_type == 'link' && 
                                                <div className='form-group'>
                                                    <label>Anchor Text</label>
                                                    <input
                                                        className='form-control'
                                                        value={field.anchor_text}
                                                        onChange={(event) => {
                                                        updateField(field, { anchor_text: event.target.value });
                                                        }}
                                                    />
                                                </div>
                                            }

                                            {field.value_type == 'select' &&
                                                <div className="row form-group">
                                                    <div className="col-md-12">
                                                    <div 
                                                        className="btn btn-primary btn-sm" 
                                                        onClick={() => setOpenModalValue(field.new)}
                                                    >
                                                        Manage Select Options
                                                    </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div className='col-md-5'>
                                            {field.record_type != "sponsorship" && (
                                                <React.Fragment>
                                                    <div className='form-group'>
                                                    <ToggleSwitch
                                                        small
                                                        id={field.new + "_visible"}
                                                        checked={field.visible}
                                                        onChange={(checked) => {
                                                            updateField(field, { visible: checked });
                                                        }}
                                                    />
                                                    <label htmlFor={field.new + "_visible"}>
                                                        Show on profile
                                                    </label>
                                                    </div>
                                                    <div className='form-group'>
                                                    <ToggleSwitch
                                                        small
                                                        id={field.new + "_editable"}
                                                        checked={field.editable}
                                                        onChange={(checked) => {
                                                            updateField(field, { editable: checked });
                                                        }}
                                                    />
                                                    <label htmlFor={field.new + "_editable"}>
                                                        Editable by {translations[field.record_type].toLowerCase()}
                                                    </label>
                                                    </div>
                                                    <div className='form-group'>
                                                    <ToggleSwitch
                                                        small
                                                        id={field.new + "_notification"}
                                                        checked={field.send_notifications}
                                                        onChange={(checked) => {
                                                            updateField(field, { send_notifications: checked });
                                                        }}
                                                    />
                                                    <label htmlFor={field.new + "_notification"}>
                                                        {field.record_type.toLowerCase() == "donor" && <>Inform {naming.beneficiary} of changes</>}
                                                        {field.record_type.toLowerCase() == "beneficiary" && <>Inform {naming.donor} of changes</>}
                                                        {field.record_type.toLowerCase() == "project" && <>Inform contacts of changes</>}
                                                    </label>
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </div>
                                        <div className='col-md-2'>
                                            <div className='form-group'>
                                                <button
                                                    onClick={() => {
                                                        handleDelete(field.new);
                                                    }}
                                                    type='button'
                                                    className='btn btn-icon btn-outline-danger'
                                                >
                                                    <i className='fa fa-trash'></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {openModalValue && openModalValue == field.new &&
                                        <SelectOptionsModal 
                                            options={field.select_options} 
                                            handleClose={(field, options) => closeOptionsModal(field, options)} 
                                            field={field}
                                        />
                                    }
                                </div>
                            ))}
                        </div>


                        <div className="dropdown show mt-3" style={{display: 'unset'}}>
                            <button className='btn btn-sm btn-outline-primary' role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                + Add Field
                            </button>

                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                {fieldType && fieldType.map((type, index) => (
                                    <a key={index} class="dropdown-item" href="#" onClick={() => addField(type)}>{capitalizeText(type)}</a>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="pt-3 text-right">
                        <button onClick={save} type="button" className="btn btn-primary mr-2" disabled={saving}>
                            {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                            Save
                        </button>

                        <button onClick={close} type="button" className="btn btn-outline-primary mr-2" disabled={saving}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
            </div>
        )}
    </div>
  )
}
